export default "__VITE_ASSET__eWGO9xga__"